{
  "lang": "nl",
  "theme": "template-toggle-clean",
  "master": "./masters/template-toggle-clean/amsterdam-jb/",
  "plugins": [
    "Dialogue",
    "a11y-describedby",
    "a11y-user-detect",
    "auto-next-when-only-radio",
    "bb-input-wrap-and-unit",
    "broadcast-fields",
    "broadcast-fields--receiver",
    "case-filter-extra",
    "case-template",
    "close-caseslist",
    "collapsable-jumplist",
    "control-filter",
    "convert-metadata",
    "custom-checkboxes",
    "custom-radios",
    "details-summary",
    "end-tools",
    "grid-tabs",
    "grid-zip-documents",
    "has-no-next",
    "headings",
    "history",
    "iconset",
    "info-inline",
    "lightbox",
    "markdown-it",
    "markdown-it-converter",
    "max-chars-indicator",
    "md-labels",
    "metadata-change-navtext",
    "mis-click-count",
    "mis-multi-click",
    "model-filter",
    "modelinfo",
    "modelitem",
    "no-fastforward",
    "no-jumplist",
    "previews",
    "progress-line",
    "progressbar",
    "questionlabelgroup-ng",
    "reset-password",
    "screentitle",
    "session-timeout-indicator",
    "shout-out-resize",
    "show-server-side-validation",
    "state-title",
    "step-x-of-n",
    "style-grid",
    "uploads",
    "wrap-table"
  ],
  "translations": {
    "next": "Volgende",
    "prior": "Vorige"
  },
  "arbitrary": {
    "headings": {
      "baseLevel": "2"
    },
    "core": {
      "skipNumButtons": true,
      "wrapAllSingleLiners": true
    },
    "previews": {
      "showChanges": true
    },
    "parentDomain": "https://intranet.amsterdam.nl/",
    "info-inline": {
      "itemheading": "h3"
    }
  },
  "template": {
    "less": {
      "post": [
        "sizes.less",
        "theme.less",
        "jumplist.less",
        "nav.less",
        "checkboxes-radios.less",
        "mobile.less"
      ]
    },
    "logo": "custom/template-toggle-clean/conf/images/logo-new.svg",
    "favicon": "images/favicon.png",
    "companyname": "Gemeente Amsterdam",
    "companywebsite": "https://www.amsterdam.nl/",
    "themeColor": "#EC0000",
    "breakpoint": "1025",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "roboto-v27",
    "amsterdam-sans"
  ]
}
